/*
 * Service to capitalize only first letter in a string
 * @param string {string} List of users
 * @returns {string} String with first letter capitalized
 */
export const capitalizeFirstLetter = (string: string): string =>
  string.charAt(0).toUpperCase() + string.slice(1);

export default capitalizeFirstLetter;
